import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ToolboxPage } from '@/features/safety/toolbox-page';

const searchSchema = z.object({
  talk: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/safety/toolbox')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <ToolboxPage projectId={projectId} talkId={search.talk} />;
}
